import React, { useMemo, useEffect, useState } from 'react'
import {
  Typography, Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Select, MenuItem, Grid, Snackbar, Alert, DialogContentText, Autocomplete, FormControlLabel, Switch,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import VisibilityIcon from '@mui/icons-material/Visibility';
import MaterialReactTable from 'material-react-table';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import RefreshIcon from '@mui/icons-material/Refresh';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';

import ButtonGroup from '@mui/material/ButtonGroup';
// import FormControlLabel from '@mui/material';
import { Tooltip, IconButton } from "@mui/material";
import colors from "assets/mavric-theme/base/colors.js";
import typography from "assets/mavric-theme/base/typography";
import borders from "assets/mavric-theme/base/borders";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import ProbeStatus_table from '../Probes/ProbeStatus_table';

const { primary, secondary, text, tableRow, transparent, white } = colors;
const { size } = typography;
const { borderRadius } = borders;
const ITEM_HEIGHT = 48;

const DemoCustomers = ({ muiTableKey, demoData, productTypeList, isAccounting, isSalesOperator, isSalesAdmin, isSupport, isDealerAdmin, isDealerOperator,
  setSelectedCustomers, showDeleteAlert, alertState, handleClickOpen, handleOpenConfirmation,
  handleClickOpenCustomerDetailView, handleDeleteCustomer, resetMyFilters, handleDeleteAlertClose, deleteAlertMsg,
  pageAlertType, openDialog, handleCloseDialog, selectedRow, handleChange, setSelectedRow,
  setShowDemoProbeTable, showDemoProbeTable, getProbesByCustomerId, probeStatusList, handleDemoCustAccountStatusChange,

  handleProductTypeChange, productType, openConfirmationDialog, handleCloseConfirmation, handleSave,
  openViewDialog, handleCloseViewCustomerDialog, confirmDeleteOpen, handleConfirmClose, handleDeleteYes,
  handleDeleteNo, deleteMessageConfirm, deleteMessageConfirmTitle, hasChanges }) => {

  const columns = useMemo(
    () => [
      {
        accessorKey: 'customer_id',
        header: 'Customer ID',
        size: 120,
        Filter: ({ header }) => (
          <Autocomplete
            size="small"
            options={customerIdOptions}
            disableCloseOnSelect
            getOptionLabel={(option) => option}
            renderOption={(props, option, { selected }) => (
              <MenuItem {...props} sx={{ "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": { backgroundColor: `${tableRow.hover} !important` } }}> {option}</MenuItem>
            )}
            style={{ width: 130 }}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" placeholder="Customer ID" />
            )}
            sx={{ '& .MuiAutocomplete-popupIndicator, & .MuiSvgIcon-root': { color: secondary.main } }}
            onChange={(event, value) =>
              header.column.setFilterValue(value)}
            clearIcon={<HighlightOffIcon fontSize="small" />}
            ListboxProps={{
              sx: {
                maxHeight: ITEM_HEIGHT * 4.5,
              }
            }}
          />
        ),
        filterFn: 'customerIdFilterFn',

      },
      {
        header: 'Customer Name',
        accessorKey: 'org_name',
        filter: 'equals',
        id: 'org_name',
        size: 150,
        Filter: ({ header }) => (
          <Autocomplete
            // multiple
            size="small"
            options={orgNameOptions}
            disableCloseOnSelect
            getOptionLabel={(option) => option}
            renderOption={(props, option, { selected }) => (
              <MenuItem {...props} sx={{ "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": { backgroundColor: `${tableRow.hover} !important` } }}> {option}</MenuItem>
            )}
            style={{ width: 150 }}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" placeholder="Customer Name" />
            )}
            sx={{ '& .MuiAutocomplete-popupIndicator, & .MuiSvgIcon-root': { color: secondary.main } }}
            onChange={(event, value) =>
              header.column.setFilterValue(value)}
            clearIcon={<HighlightOffIcon fontSize="small" />}
            ListboxProps={{
              sx: {
                maxHeight: ITEM_HEIGHT * 4.5,
              }
            }}
          />
        ),
        filterFn: 'customerNameFilterFn',

      },
      {
        accessorKey: 'product_type',
        header: 'Product Type',
        size: 120,
        Filter: ({ header }) => (
          <Autocomplete
            size="small"
            options={productTypeOptions}
            disableCloseOnSelect
            getOptionLabel={(option) => option}
            renderOption={(props, option, { selected }) => (
              <MenuItem {...props} sx={{ "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": { backgroundColor: `${tableRow.hover} !important` } }}> {option} </MenuItem>
            )}
            style={{ width: 140 }}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" placeholder="Product Type" />
            )}
            sx={{ '& .MuiAutocomplete-popupIndicator, & .MuiSvgIcon-root': { color: secondary.main } }}
            onChange={(event, value) =>
              header.column.setFilterValue(value)}
            clearIcon={<HighlightOffIcon fontSize="small" />}
            ListboxProps={{ sx: { maxHeight: ITEM_HEIGHT * 4.5, } }}
          />
        ),
        filterFn: 'productTypeFilterFn',

      },

      {
        accessorKey: 'is_active',
        header: 'Status',
        id: 'status',
        size: 120,
        Filter: ({ header }) => (
          <Autocomplete
            size="small"
            // options={statusOptions}
            options={['Active', 'Inactive']}
            getOptionLabel={(option) => option}
            renderOption={(props, option) => (
              <MenuItem {...props} sx={{ "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": { backgroundColor: `${tableRow.hover} !important` } }}>
                {option}
              </MenuItem>
            )}
            style={{ width: 120 }}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" placeholder="Status" />
            )}
            sx={{ '& .MuiAutocomplete-popupIndicator, & .MuiSvgIcon-root': { color: secondary.main } }}
            onChange={(event, value) => {
              const boolVal = value === 'Active' ? true : value === 'Inactive' ? false : null;
              header.column.setFilterValue(boolVal);
            }}
            clearIcon={<HighlightOffIcon fontSize="small" />}
            ListboxProps={{ sx: { maxHeight: ITEM_HEIGHT * 4.5 } }}
          />
        ),

        Cell: ({ cell }) => {
          const value = cell.getValue();
          return (
            <span style={{ color: value ? text.main : text.disabled }}>
              {value ? 'ACTIVE' : 'INACTIVE'}
            </span>
          );
        },
        filterFn: 'statusFilterFn',
      },

      // {
      //   accessorKey: 'act_type',
      //   header: 'Account Type',
      //   id: 'act_type',
      //   size: 110,
      //   enableColumnFilter: false,
      // },

      {
        accessorKey: 'created_by',
        header: 'Created By',
        id: 'created_by',
        size: 120,
        enableColumnFilter: false,
      },

      {
        accessorKey: 'updated_by',
        header: 'Updated By',
        id: 'updated_by',
        size: 120,
        enableColumnFilter: false,
      },

      {
        accessorKey: 'account_activation_updated_on',
        header: 'Activation Time',
        id: 'account_activation_updated_on',
        size: 150,
        enableColumnFilter: false,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value ? new Date(value).toLocaleString() : '-';
        },
        sortDescFirst: true
      },

      {
        accessorKey: 'last_modified_on',
        header: 'Modified Time',
        id: 'last_modified_on',
        size: 150,
        enableColumnFilter: false,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return value ? new Date(value).toLocaleString() : '-';
        },
      },

    ],
    [],
  );

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [orgNameOptions, setOrgNameOptions] = useState([]);
  const [customerIdOptions, setCustomerIdOptions] = useState([]);
  const [productTypeOptions, setProductTypeOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const { vertical, horizontal } = alertState;

  useEffect(() => {
    if (Array.isArray(demoData) && demoData.length > 0) {
      prepareDemoCustomerData(demoData);
    }
  }, [demoData]);

  const prepareDemoCustomerData = (data) => {
    let updtdOrgNameOptions = orgNameOptions;
    let updtdCustIdOptions = customerIdOptions;
    let updtdProdTypeOptions = productTypeOptions;
    let updtdStatusOptions = statusOptions;

    data.map(row => {
      const isDuplicateOrgName = updtdOrgNameOptions.includes(row.org_name);
      const isDuplicateCustId = updtdCustIdOptions.includes(row.customer_id);
      const isDuplicateProdType = updtdProdTypeOptions.includes(row.product_type);
      const status = row.is_active ? 'ACTIVE' : 'INACTIVE';
      const isDuplicateStatus = updtdStatusOptions.includes(status);

      if (!isDuplicateOrgName) {
        updtdOrgNameOptions.push(row.org_name);
      }

      if (!isDuplicateCustId) {
        updtdCustIdOptions.push(String(row.customer_id));
      }

      if (!isDuplicateProdType) {
        updtdProdTypeOptions.push(row.product_type);
      }

      if (!isDuplicateStatus) {
        updtdStatusOptions.push(status);
      }

    });
    setOrgNameOptions(updtdOrgNameOptions.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
    setCustomerIdOptions(updtdCustIdOptions.sort(((a, b) => parseInt(a) - parseInt(b))));
    setProductTypeOptions(updtdProdTypeOptions.sort());
    setStatusOptions(updtdStatusOptions.sort());

  }

  return (
    <div>
      {demoData.length === 0 ? <Typography sx={{ display: 'flex', justifyContent: 'center', color: '#8080807a', }}>No Data Found</Typography> :
        <MaterialReactTable
          key={muiTableKey}
          columns={columns}
          data={demoData}

          muiTableToolbarAlertBannerProps={{ sx: { display: 'none' } }}
          muiTablePaperProps={{ sx: { boxShadow: 'none', backgroundColor: primary.main } }}
          muiTableBodyRowProps={({ row }) => ({
            hover: true,
            sx: {
              color: text.main,
              align: 'center',
              '&:nth-of-type(odd)': {
                backgroundColor: tableRow.dark,
                border: 0,
              },
              '&:nth-of-type(even)': {
                background: tableRow.light,
              },
              // hide last border
              '&:last-child td, &:last-child th': {
                border: 0,
              },
              '&:hover td': {
                background: tableRow.hover,
              },
            },
          })}
          //muiTableBodyProps={{sx:{boxShadow: 'none'}}}
          muiTableBodyCellProps={{ sx: { border: 'none', color: text.main, align: 'center', boxShadow: 'none', padding: '4px 8px', } }}
          muiTableProps={{ sx: { backgroundColor: primary.main, color: text.main, boxShadow: 'none' } }}
          // muiTableToolbarTopProps={{ sx: {backgroundColor: primary.main, boxShadow: 'none', minHeight: 0} }}
          // muiTableToolbarBottomProps={{ sx: {backgroundColor: primary.main, boxShadow: 'none'} }}
          muiTopToolbarProps={{ sx: { backgroundColor: primary.main, boxShadow: 'none', minHeight: 0 } }}
          muiBottomToolbarProps={{ sx: { backgroundColor: primary.main, boxShadow: 'none' } }}
          muiTableHeadRowProps={{ sx: { backgroundColor: primary.main, color: text.main, textAlign: 'center' }, }}
          muiTableHeadCellProps={{ sx: { borderBottom: 0, verticalAlign: 'none', boxShadow: 'none', align: 'center', color: text.main } }}
          // enableToolbarTop={false}
          // enableColumnFilters={true}
          enableRowSelection={(isAccounting || isSalesOperator || isSalesAdmin || isDealerAdmin || isDealerOperator) ? true : false}
          // enableSorting={false}
          enableColumnActions={false}
          enableSelectAll={false}
          enableRowActions
          positionPagination="bottom"
          enableToolbarInternalActions={false}
          initialState={{
            density: 'compact',
            showColumnFilters: true,
            boxShadow: 'none',
            pagination: { pageSize: 10, pageIndex: 0, pageCount: -1, },
            sorting: [
              {
                id: 'account_activation_updated_on', //sort by account_activation_updated_on by default on page load
                desc: true,
              }
            ],
          }}
          positionActionsColumn="last"
          muiTablePaginationProps={{
            rowsPerPageOptions: [3, 5, 10, 15, 20],
            sx: { color: text.main, '& p': { marginBottom: 0 },'& .MuiSvgIcon-root': { color: text.main, }, }
          }}
          renderTopToolbar={({ table }) => {
            const handleDeleteCustomers = () => {
              handleDeleteCustomer();
              table.getSelectedRowModel().flatRows.map((row) => {
                setSelectedCustomers(current => [...current, row.original]);
              });
            };

            return (
              <>
                {(isAccounting || isSalesOperator || isSalesAdmin || isDealerAdmin || isDealerOperator) ?
                  (<div style={{ backgroundColor: primary.main }}>
                    <Button
                      color="secondary"
                      disabled={table.getSelectedRowModel().flatRows.length > 1 || table.getSelectedRowModel().flatRows.length === 0}
                      onClick={handleDeleteCustomers}
                      variant="contained"
                      size="small"
                      sx={{ mr: 1, ml: 1, mb: 1 }}
                    >
                      Delete Customer
                    </Button>
                    <Button onClick={resetMyFilters} mr={2} variant="contained"
                      sx={{
                        '&:hover': {
                          backgroundColor: secondary.main,
                        },
                        mb: 1,
                      }} color="secondary" size="small" startIcon={<RefreshIcon sx={{ backgroundColor: secondary.main }} size="small" />}>
                      Reset Filters
                    </Button>
                  </div>) : (<></>)
                }
              </>
            );
          }}
          renderRowActions={({ row }) => (
            <div style={{ display: 'flex', flexWrap: 'nowrap', gap: '0.5rem' }}>

              {/* &nbsp; &nbsp; */}
              {(isAccounting || isSalesOperator || isSalesAdmin || isDealerAdmin || isDealerOperator) ?
                (<ButtonGroup variant="text" color="primary" size="small" aria-label="text primary button group">
                  <Tooltip title="View" aria-label="Apply">
                    <IconButton sx={{
                      border: 1, borderRadius: 2, backgroundColor: secondary.main, borderColor: secondary.main, width: 30, height: 30,
                      '&:hover': {
                        backgroundColor: secondary.main,
                      },
                    }} color="text" size="small"
                      onClick={() => {
                        handleClickOpenCustomerDetailView(row.original)
                      }}
                    >
                      <VisibilityIcon style={{ backgroundColor: secondary.main }} size="small" />
                    </IconButton>
                  </Tooltip>
                  &nbsp;&nbsp;
                  <Tooltip title="Edit" aria-label="Rename Matrix">
                    <IconButton sx={{
                      border: 1, borderRadius: 2, backgroundColor: secondary.main, borderColor: secondary.main,
                      width: 30, height: 30,
                      '&:hover': {
                        backgroundColor: secondary.main,
                      },
                    }} color="text" size="small"
                      onClick={() => {
                        handleClickOpen(row.original)
                      }}
                    >
                      <EditIcon style={{ backgroundColor: secondary.main }} size="small" />
                    </IconButton>
                  </Tooltip>
                </ButtonGroup>
                ) :
                (<ButtonGroup variant="text" color="primary" size="small" aria-label="text primary button group">
                  <Tooltip title="View" aria-label="Apply">
                    <IconButton sx={{
                      border: 1, borderRadius: 2, backgroundColor: secondary.main, borderColor: secondary.main, width: 30, height: 30,
                      '&:hover': {
                        backgroundColor: secondary.main,
                      },
                    }} color="text" size="small"
                      onClick={() => {
                        handleClickOpenCustomerDetailView(row.original)
                      }}
                    >
                      <VisibilityIcon style={{ backgroundColor: secondary.main }} size="small" />
                    </IconButton>
                  </Tooltip>
                </ButtonGroup>
                )
              }
            </div>
          )}

          filterFns={{
            customerIdFilterFn: (row, _columnIds, filterValue) => {
              if (filterValue !== null) {
                if (filterValue !== 'All') {
                  return String(row.getValue('customer_id')) === filterValue;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            },
            customerNameFilterFn: (row, _columnIds, filterValue) => {
              if (filterValue !== null) {
                if (filterValue !== 'All') {
                  return row.getValue('org_name') === filterValue;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            },
            productTypeFilterFn: (row, _columnIds, filterValue) => {
              if (filterValue !== null) {
                if (filterValue !== 'All') {
                  return row.getValue('product_type') === filterValue;
                } else {
                  return true;
                }
              } else {
                return true;
              }
            },
            statusFilterFn: (row, _columnIds, filterValue) => {
              // console.log('nameFilterFn', _columnIds, filterValue);
              // if (filterValue !== null) {
              //   if (filterValue !== 'All') {
              //     return row.getValue('status') === filterValue;
              //   } else {
              //     return true;
              //   }
              // } else {
              //   return true;
              // }
              if (filterValue === null || filterValue === undefined) return true;
              return row.original.is_active === filterValue;
            },
          }}
        />
      }

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        // fullScreen={fullScreen}
        maxWidth={showDemoProbeTable ? "lg" : "sm"}
        // maxWidth={maxWidth}
        // scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        sx={{
          '& .MuiDialog-paper': {
            backgroundColor: primary.main,
          }
        }}
      >
        <DialogTitle>
          <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 2 }} gutterBottom>
            {'Edit Demo Customer Details'}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} direction="row">
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Typography variant="body2" fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>Customer Name</Typography>
              <TextField
                id="org_name"
                name="org_name"
                placeholder="Customer Name"
                value={selectedRow ? (selectedRow.org_name !== null ? selectedRow.org_name : '') : ''}
                focused={false}
                size='small'
                slotprops={{
                  input: {
                    readOnly: true,
                  },
                }}
                disabled={true}
                sx={{
                  width: 200,
                  color: text.main,
                  borderColor: primary.focus,
                  backgroundColor: transparent.main,
                  borderRadius: borderRadius.md,
                }}
                onChange={handleChange}
              //fullWidth
              //autoComplete="given-name"
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Typography variant="body2" fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>Product Name</Typography>
              <Select
                fullWidth
                sx={{ width: 200 }}
                name="product_type"
                value={productType || ''}
                onChange={handleProductTypeChange}
              >
                {productTypeList.map((item) => (
                  <MenuItem
                    key={item.product_id}
                    value={item.product_type}
                  >
                    {item.product_type}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            {/* Account Status (Active/Inactive) */}
            {/* <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography variant="body2" fontSize={size.xs} color={text.main} sx={{ fontWeight: 400 }}>
                Account Status
              </Typography>
              <FormControlLabel
                control={
                  <Switch
                    checked={selectedRow && selectedRow.is_active ? true : false}
                    onChange={(e) => {
                      setSelectedRow({
                        ...selectedRow,
                        is_active: e.target.checked
                      });
                    }}
                    color="secondary"
                  />
                }
                label={selectedRow?.is_active ? 'Active' : 'Inactive'}
                sx={{ color: text.main }}
              />
            </Grid> */}

            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Typography variant="body2" fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>
                Account Status
              </Typography>
              {/* <FormControl fullWidth size="small" sx={{ mt: 1 }}> */}
              <Select
                fullWidth
                name="status"
                sx={{ width: 200 }}
                value={selectedRow && selectedRow.is_active ? 'active' : 'inactive'}
                // onChange={(e) => {
                //   const { name, value } = e.target;
                //   setSelectedRow({
                //     ...selectedRow,
                //     is_active: e.target.value === 'active'
                //   });
                //   if (name === 'is_active') {
                //     const wasActive = selectedRow.is_active; 
                //     setShowDemoProbeTable(wasActive);}

                // }}
                onChange={handleDemoCustAccountStatusChange}
                color="secondary"
              >
                <MenuItem value="active">Active</MenuItem>
                <MenuItem value="inactive">Inactive</MenuItem>
              </Select>
              {/* </FormControl> */}
            </Grid>


            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>
                Account Type
              </Typography>
              <Select
                fullWidth
                sx={{ width: 200 }}
                name="account_type"
                // value={selectedRow?.act_type || ''}
                value={selectedRow && selectedRow.act_type ? selectedRow.act_type : ''}
                onChange={(e) => {
                  setSelectedRow({
                    ...selectedRow,
                    act_type: e.target.value
                  });
                }}
              >
                <MenuItem value="demo">Demo</MenuItem>
                <MenuItem value="billed">Billed</MenuItem>
              </Select>
            </Grid>

          </Grid>
          {showDemoProbeTable && (
            <>
              <Divider sx={{ borderColor: primary.divider, mt: 2, mb: 2 }} />

              <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 1 }}>
                Probes Details
              </Typography>

              <Box sx={{ width: "100%" }}>
                {probeStatusList.length > 0 ? (
                  <ProbeStatus_table
                    data={probeStatusList}
                    getProbesByCustomerId={getProbesByCustomerId}
                    selectedCustomer={selectedRow}
                  />
                ) : (
                  <Box m={4} p={4} sx={{ display: "flex", justifyContent: "center" }}>
                    <Typography variant="body2" color={text.main} sx={{ fontWeight: 600 }}>
                      No Probe Details
                    </Typography>
                  </Box>
                )}
              </Box>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="secondary" variant="contained" sx={{ borderRadius: "4px", padding: "10px 20px", }}>
            Cancel
          </Button>
          <Button onClick={handleOpenConfirmation} color="secondary" disabled={!hasChanges()} variant="contained" sx={{ borderRadius: "4px", padding: "10px 20px", }}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openConfirmationDialog}
        onClose={handleCloseConfirmation}
        fullScreen={fullScreen}
        // maxWidth={maxWidth}
        // scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        sx={{
          '& .MuiDialog-paper': {
            backgroundColor: primary.main,
          }
        }}
      >
        <DialogTitle>
          <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 2 }} gutterBottom>
            {'Confirmation'}
          </Typography>
        </DialogTitle>
        <DialogContent>
          Are you sure you want to save the changes?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseConfirmation} color="secondary" variant="contained">
            No
          </Button>
          <Button onClick={handleSave} color="secondary" variant="contained" >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openViewDialog}
        onClose={handleCloseViewCustomerDialog}
        fullScreen={fullScreen}
        // maxWidth={maxWidth}
        // scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        sx={{
          '& .MuiDialog-paper': {
            backgroundColor: primary.main,
          }
        }}
      >
        <DialogTitle>
          <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 2 }} gutterBottom>
            {'View Demo Customer Details'}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} direction="row">
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Typography variant="body2" fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>Customer Name</Typography>
              <TextField
                id="org_name"
                name="org_name"
                placeholder="Customer Name"
                value={selectedRow ? (selectedRow.org_name !== null ? selectedRow.org_name : '') : ''}
                focused={false}
                slotprops={{
                  input: {
                    readOnly: true,
                  },
                }}
                disabled={true}
                sx={{
                  width: 200,
                  color: text.main,
                  borderColor: primary.focus,
                  backgroundColor: transparent.main,
                  borderRadius: borderRadius.md,
                }}
              // onChange={handleChange}
              //fullWidth
              //autoComplete="given-name"
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Typography variant="body2" fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>Product Name</Typography>
              <TextField
                id="product_type"
                name="product_type"
                placeholder="Product Type"
                value={productType || ''}
                focused={false}
                slotprops={{
                  input: {
                    readOnly: true,
                  },
                }}
                disabled={true}
                sx={{
                  width: 200,
                  color: text.main,
                  borderColor: primary.focus,
                  backgroundColor: transparent.main,
                  borderRadius: borderRadius.md,
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Typography variant="body2" fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>
                Account Status
              </Typography>
              <TextField
                name="status"
                // sx={{ width: 200 }}
                value={selectedRow && selectedRow.is_active ? 'active' : 'inactive'}
                focused={false}
                slotprops={{
                  input: {
                    readOnly: true,
                  },
                }}
                disabled={true}
                sx={{
                  width: 200,
                  color: text.main,
                  borderColor: primary.focus,
                  backgroundColor: transparent.main,
                  borderRadius: borderRadius.md,
                }}
              />
            </Grid>


            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Typography variant="body2" fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>
                Account Type
              </Typography>
              <TextField
                name="account_type"
                // value={selectedRow?.act_type || ''}
                value={selectedRow && selectedRow.act_type ? selectedRow.act_type : ''}
                focused={false}
                slotprops={{
                  input: {
                    readOnly: true,
                  },
                }}
                disabled={true}
                sx={{
                  width: 200,
                  color: text.main,
                  borderColor: primary.focus,
                  backgroundColor: transparent.main,
                  borderRadius: borderRadius.md,
                }}
              />
            </Grid>

          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseViewCustomerDialog} color="secondary" variant="contained" sx={{ borderRadius: "4px", padding: "10px 20px", }}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={confirmDeleteOpen}
        onClose={handleConfirmClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth='md'
        sx={{
          '& .MuiDialog-paper': {
            backgroundColor: primary.main,
          }
        }}
      >
        <DialogTitle id="alert-dialog-title">
          <Typography fontSize={size.lg} color={secondary.main} sx={{ fontWeight: 600, }}>{deleteMessageConfirmTitle}</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{deleteMessageConfirm}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="secondary" startIcon={<CancelIcon />}
            onClick={handleDeleteNo}>No</Button>

          <Button variant="contained" color="secondary" startIcon={<DeleteIcon />}
            onClick={handleDeleteYes} autoFocus>Yes</Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={showDeleteAlert}
        autoHideDuration={6000}
        key={vertical + horizontal}
        onClose={handleDeleteAlertClose}
      >
        <Alert elevation={6} variant="filled" onClose={handleDeleteAlertClose}
          severity={pageAlertType || "error"} sx={{ "& .MuiAlert-message": { color: white.main, fontSize: size.sm }, marginBottom: 4 }}
        >
          {deleteAlertMsg}
        </Alert>
      </Snackbar>
    </div>
  )
}

export default DemoCustomers
